/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type { BadgesRetrievePathOrgUnitId, BadgesRetrieveStatus200 } from "../types/BadgesRetrieve.ts";

function getBadgesRetrieveUrl(org_unit_id: BadgesRetrievePathOrgUnitId) {
	const res = { method: "GET", url: `/api/${org_unit_id}/badges/` as const };

	return res;
}

/**
 * @description Справочник тегов (бейджей) блюд для киоска и QR-меню.
 * {@link /api/:org_unit_id/badges/}
 */
export async function badgesRetrieve(org_unit_id: BadgesRetrievePathOrgUnitId, config: Partial<RequestConfig> & { client?: Client } = {}) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<BadgesRetrieveStatus200, ResponseErrorConfig<Error>, unknown>({
		method: "GET",
		url: getBadgesRetrieveUrl(org_unit_id).url.toString(),
		...requestConfig,
	});

	return res.data;
}
